import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../rest-api.service';

@Component({
  selector: 'app-cart-page',
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.css']
})
export class CartPageComponent implements OnInit {
  public hasOrderNumber: boolean = false;
  public orderNumber: string;
  public cartInfo: any;
  public stripeId: any;
  public subtotal: string;
  public tax: string;
  public shipping: string;
  public total: string;

  constructor(private restApi: RestApiService) { }

  ngOnInit() {
    this.restApi.orderNumber.subscribe((evt) => {
      const orderInfo = evt;
      this.orderNumber = orderInfo.order_id;
      this.stripeId = orderInfo.stripe_id;
      this.cartInfo = orderInfo.cart_info;
      this.subtotal = orderInfo.subtotal;
      this.tax = orderInfo.tax;
      this.shipping = orderInfo.shipping;
      this.total = orderInfo.total;
      this.hasOrderNumber = true;
    });
  }

}
